import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { getCurrentUser, hasAccess } from "../helpers/session_helper";

// ─── Per-system menu slices ───────────────────────────────────────────────────
import { coreMenuItems } from "./Components/CoreMenuItems";
import { buildHRISMenuItems } from "./Components/HRISMenuItems";
import { payrollMenuItems } from "./Components/PayrollMenuItems";

const Navdata = () => {
  const history = useNavigate();
  const location = useLocation();

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  const shouldFetch = getCurrentUser();
  const { data, refetch } = useGetAccessUsersQuery({}, { skip: !shouldFetch });
  const accessRights = data?.returnData?.map(({ permissionTypeId, allowRead, allowWrite, allowDelete }) => ({
    permissionTypeId, allowRead, allowWrite, allowDelete,
  }));

  useEffect(() => { refetch(); }, [location.pathname]);
  useEffect(() => {
    if (accessRights) sessionStorage.setItem("accessRights", JSON.stringify(accessRights));
  }, [accessRights]);

  // ── Top-level collapse states ───────────────────────────────────────────
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isDashboard, setIsDashboard] = useState(false);
  const [isHRIS, setIsHRIS] = useState(false);
  const [isPayroll, setIsPayroll] = useState(false);

  // ── HRIS sub-collapse ─────────────────────────────────────────────
  const [isHRISWorkforce, setIsHRISWorkforce] = useState(false);
  const [isHRISTimekeeping, setIsHRISTimekeeping] = useState(false);
  const [isHRISSelfService, setIsHRISSelfService] = useState(false);
  const [isHRISRecruitment, setIsHRISRecruitment] = useState(false);

  // ── Auto-collapse on section change ────────────────────────────────────
  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Apps") setIsApps(false);
    if (iscurrentState !== "Auth") setIsAuth(false);
    if (iscurrentState !== "Pages") setIsPages(false);
    if (iscurrentState !== "Dashboard") setIsDashboard(false);
    if (iscurrentState !== "Payroll") setIsPayroll(false);

    // HRIS — collapse the outer accordion AND all inner sub-groups
    // when the user navigates away from any HRIS page.
    // Guard against "HRISPriv*" so the private accordion isn't collapsed here.
    if (!iscurrentState.startsWith("HRIS") || iscurrentState.startsWith("HRISPriv")) {
      setIsHRIS(false);
      setIsHRISWorkforce(false);
      setIsHRISTimekeeping(false);
      setIsHRISSelfService(false);
      setIsHRISRecruitment(false);
    }
  }, [history, iscurrentState]);


  // ── Build HRIS items ──────────────────────────────────────────────
  const hrisMenuItems = buildHRISMenuItems({
    isHRISWorkforce, setIsHRISWorkforce,
    isHRISTimekeeping, setIsHRISTimekeeping,
    isHRISSelfService, setIsHRISSelfService,
    isHRISRecruitment, setIsHRISRecruitment,
    setIscurrentState,
  });

  // ── withToggle — wires outer accordion state onto top-level menu items ──
  function withToggle(items, stateVar, setter, stateKey) {
    return items.map(function (item) {
      if (!item.subItems) return item;
      return Object.assign({}, item, {
        stateVariables: stateVar,
        click: function (e) {
          e.preventDefault();
          setter(!stateVar);
          setIscurrentState(stateKey);
        },
      });
    });
  }

  // ── Assemble full menu ──────────────────────────────────────────────────
  const SYSTEMS_HEADER_IDX = 1;
  const beforeSystems = coreMenuItems.slice(0, SYSTEMS_HEADER_IDX + 1);
  const afterSystems = coreMenuItems.slice(SYSTEMS_HEADER_IDX + 1);

  const menuItems = [
    ...beforeSystems,
    ...withToggle(hrisMenuItems, isHRIS, setIsHRIS, "HRIS"),
    ...withToggle(payrollMenuItems, isPayroll, setIsPayroll, "Payroll"),
    ...afterSystems,
  ];

  // ── Permission filter ───────────────────────────────────────────────────
  const filterMenu = (items) => {
    return items
      .filter(item => hasAccess(item.permissionTypeId, accessRights))
      .map(item => {
        const newItem = { ...item };
        if (item.subItems) {
          newItem.subItems = filterMenu(item.subItems);
          if (newItem.subItems.length === 0) return null;
        }
        if (item.childItems) {
          newItem.childItems = filterMenu(item.childItems);
          if (newItem.childItems.length === 0) return null;
        }
        return newItem;
      })
      .filter(Boolean);
  };

  return <React.Fragment>{filterMenu(menuItems)}</React.Fragment>;
};

export default Navdata;